import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';
import { getAppInfo } from '../settings.js';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },{
    path: '/index',
    name: 'index',
    redirect: '/login'
  },{
    path: '/bridge',
    name: 'bridge',
    component: () => import('@/views/bridge.vue'),
    children: []
  },{
  path: '/login',
  name: 'login',
  component: () => import('@/views/smsrepayment/login.vue'),
    children: []
  },{
    path: '/cancel_phone',
    name: 'cancel_phone',
    component: () => import('@/views/user/cancel_phone.vue'),
    children: []
  },{
    path: '/cancel_code',
    name: 'cancel_code',
    component: () => import('@/views/user/cancel_code.vue'),
    children: []
  },{
    path: '/agreementList',
    name: 'agreementList',
    component: () => import('@/views/agreements/list.vue'),
    children: []
  },{
    path: '/agreementTabList',
    name: 'agreementTabList',
    component: () => import('@/views/agreements/tabList.vue'),
    children: []
  },{
    path: '/agreementTabListLoan',
    name: 'agreementTabListLoan',
    component: () => import('@/views/agreements/tabListLoan.vue'),
    children: []
  },{
    path: '/agreementList_detail',
    name: 'agreementList_detail',
    component: () => import('@/views/agreements/detail.vue'),
    children: []
  },{
    path: '/agreementList_aboutUs',
    name: 'agreementList_aboutUs',
    component: () => import('@/views/agreements/aboutUs.vue'),
    children: []
  },{
    path: '/repayment_detail',
    name: 'repayment_detail',
    component: () => import('@/views/repayment/detail.vue'),
    children: []
  },{
    path: '/repayment_method',
    name: 'repayment_method',
    component: () => import('@/views/repayment/method.vue'),
    children: []
  },{
    path: '/repayment_methodList',
    name: 'repayment_methodList',
    component: () => import('@/views/repayment/method.vue'),
    children: []
  },  {
    path: '/repayment_code',
    name: 'repayment_code',
    component: () => import('@/views/repayment/code.vue'),
    children: []
  },{
    path: '/repayment_qrCode_details',
    name: 'repayment_qrCode_details',
    component: () => import('@/views/repayment/repaymentQrCodeDetails.vue'),
    children: []
  },{
  path: '/smsrepayment-method',
    name: 'smsrepayment-method',
    component: () => import('@/views/smsrepayment/method.vue'),
    children: []
  },{
    path: '/smsrepayment-code',
    name: 'smsrepayment-code',
    component: () => import('@/views/smsrepayment/code.vue'),
    children: []
  },{
    path: '/smsrepayment_qrCode_details',
    name: 'smsrepayment_qrCode_details',
    component: () => import('@/views/smsrepayment/qrCodeDetails.vue'),
    children: []
  },{
    path: '/smsrepayment-verify',
    name: 'smsrepayment-verify',
    component: () => import('@/views/smsrepayment/verify.vue'),
    children: []
  },{
    path: '/smsrepayment-login',
    name: 'smsrepayment-login',
    component: () => import('@/views/smsrepayment/login.vue'),
    children: []
  },{
    // H5短链入催入口页（处理guideH5 + 自动跳转）
    path: '/repayment/h5',
    name: 'repayment-h5',
    component: () => import('@/views/smsrepayment/h5.vue'),
    children: []
  },{
    // H5短链入催合同列表页（debtDetails sourceDesc=3）
    path: '/repayment/h5/list',
    name: 'repayment-h5-list',
    component: () => import('@/views/smsrepayment/list.vue'),
    children: []
  },
{
    path: '/faceFail',
    name: 'faceFail',
    component: () => import('@/views/remind/faceFail.vue'),
    children: []
  },
  {
    path: '/payment_history',
    name: 'payment_history',
    component: () => import('@/views/payment/history.vue'),
    children: []
  },{
    path: '/payment_detail',
    name: 'payment_detail',
    component: () => import('@/views/payment/detail.vue'),
    children: []
  },{
    path: '/smartcustomer',
    name: 'smartcustomer',
    component: () => import('@/views/smartcustomer/index.vue'),
    children: []
  },
  {
    path: '/coupon_center',
    name: 'coupon_center',
    component: () => import('@/views/coupon/CouponCenter.vue'),
    children: []
  },
  {
    path: '/coupon_history',
    name: 'coupon_history',
    component: () => import('@/views/coupon/CouponHistory.vue'),
    children: []
  },{
    path: '/feedback',
    name: 'feedback',
    component: () => import('@/views/feedback/feedback.vue'),
    children: []
  },{
    path: '/feedback/success',
    name: 'feedbackSuccess',
    component: () => import('@/views/feedback/feedbackSuccess.vue'),
    children: []
  },{
    path: '/compliance',
    name: 'compliance',
    component: () => import('@/views/compliance/index.vue'),
    children: []
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

router.beforeEach((to, from, next) => {
  getAppInfo(() => {
    next();
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js